export enum AnswerFormat {
  DEFAULT = '',
  CURRENCY = 'currency',
  YEAR_ONLY = 'year',
}
